// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsProductsDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      name: string,
      blacklisted: boolean,
      known: maybe(boolean, true),
    })
  ),
});
